"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunk47DQFHHMcjs = require('./chunk-47DQFHHM.cjs');


var _chunkQQGUWBEMcjs = require('./chunk-QQGUWBEM.cjs');


var _chunkODN24ORCcjs = require('./chunk-ODN24ORC.cjs');


var _chunkJLYOJWE3cjs = require('./chunk-JLYOJWE3.cjs');

// src/contracts/farm/index.ts
var FARM4 = {
  [_chunkJLYOJWE3cjs.FARM_VERSION.v1]: _chunkQQGUWBEMcjs.FARM,
  [_chunkJLYOJWE3cjs.FARM_VERSION.v2]: _chunkODN24ORCcjs.FARM,
  [_chunkJLYOJWE3cjs.FARM_VERSION.v3]: _chunk47DQFHHMcjs.FARM
};



exports.FARM = FARM4;
//# sourceMappingURL=chunk-WFVWYVQQ.cjs.map